export default __webpack_public_path__ + "static/js/pdf.worker.8862b207.js";